import { FC, SyntheticEvent } from "react";
import { Box, Image, Skeleton } from "@chakra-ui/react";

import fallbackBankIcon from "../../../../../assets/bank.svg";

interface Props {
  logoURL?: string;
  bankName?: string;
}

export const SbpTransferBanksPageBankImage: FC<Props> = ({ logoURL, bankName }) => {
  const src = logoURL ? logoURL : fallbackBankIcon;

  const onLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    const skeleton = e.currentTarget.previousSibling;
    if (skeleton) {
      (skeleton as HTMLElement).style.display = "none";
    }

    e.currentTarget.style.opacity = "1";
  };

  const onError = (e: SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.src = fallbackBankIcon;
    img.onerror = null;

    const skeleton = img.previousSibling;
    if (skeleton) {
      (skeleton as HTMLElement).style.display = "none";
    }

    img.style.opacity = "1";
  };

  return (
    <Box position="relative" boxSize="36px" mr="10px">
      <Skeleton boxSize="36px" borderRadius="6px" position="absolute" top="0" left="0" />

      <Image
        src={src}
        alt={bankName || "Банк"}
        onLoad={onLoad}
        onError={onError}
        boxSize="36px"
        borderRadius="6px"
        objectFit="contain"
        loading="lazy"
        position="absolute"
        top="0"
        left="0"
        opacity="0"
        transition="opacity 0.2s"
      />
    </Box>
  );
};
